(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsCompleteController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'NotificationFactory'];

  function reports ($scope, $http, $timeout, ngTableParams, NotificationFactory) {
    var vm = this;

    	$scope.vm = vm;
    vm.loading = false;
    vm.sendApi = false;
    vm.total = 0;
    vm.filterTable = [
      { text: 'Whatsapp' },
      { text: 'Chat' },
      { text: 'E-mail' },
      { text: 'Facebook' },
      { text: 'SMS' }
    ];
    vm.autocompleteTable = [
      { text: 'Whatsapp' },
      { text: 'Chat' },
      { text: 'E-mail' },
      { text: 'Facebook' },
      { text: 'SMS' }
    ]

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.reload = function () {
      vm.loading = true;
      vm.sendApi = true;
      gdata = {};

      $http.get(apiUrl + '/reports/complete', {
        // params: params.url()
        params: {
          filters: vm.filters
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success === false) {
            notifSet.addNotification({
              title: 'Erro!',
              content: data.error_message,
              color: 'alert',
              autoclose: 3000
            });
            vm.data = {};
            vm.data_by_number = {};
            vm.table_data = {};

            vm.loading = false;

            return;
          }

          function addOthers (data, data_total) {
            var total = 0; var count = 0;
            var outros = '';
            for (var i in data) {
              count = vm.percent(data[i].count, data_total);
              if (count == 0) {
                outros += data[i].name + ' (' + data[i].count + ')<br>';
              } else {
                total += count;
              }
            }
            if (total < 100 && outros.length > 0) {
              data['others'] = {
                width: 100 - total,
                tooltip: 'Outros: <br>' + outros
              };
            }
            return data;
          }
          addOthers(data.result.sectors.whatsapp, data.result.total_sectors.whatsapp);
          addOthers(data.result.sectors.chat, data.result.total_sectors.chat);
          addOthers(data.result.sectors.email, data.result.total_sectors.email);

          addOthers(data.result.status.whatsapp, data.result.total_status.whatsapp);
          addOthers(data.result.status.chat, data.result.total_status.chat);
          addOthers(data.result.status.email, data.result.total_status.email);

          data.result.contacts.total = data.result.contacts.whatsapp + data.result.contacts.email + data.result.contacts.chat + data.result.contacts.facebook + data.result.contacts.sms;
          vm.data = data.result;
          vm.data_by_number = data.data_by_number;

          gdata = data.table;
          vm.table_data = data.table;
          vm.table.reload();
          vm.loading = false;
        }, function (error) { console.log(error) });
    };

    vm.table = new ngTableParams({
      page: 1,
      total: 50
    }, {
      getData: function ($defer, params) {
        params.total(gdata.total);
        $defer.resolve(gdata.result);
      }
    });

    var gdata = {};

    vm.objLength = function (obj) {
      if (!obj) {
        return 0;
      }
      if (typeof obj === 'array') {
        return obj.length;
      }
      return Object.keys(obj).length;
    };

    vm.percent = function (value, total) {
      var value = Math.floor(((value * 100) / total) * 100) / 100;
      if (Math.floor(value) == 0) {
        return 0;
      }
      return value;
    };
    vm.percentDisplay = function (value, total) {
      return ((value * 100) / total).toFixed(2); ;
    };

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    vm.downloadCsvGraph = function () {
      var csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += 'Entrada,';
      var sectors = {};
      var statuses = {};
      for (var sector_id in vm.data.sectors.whatsapp) {
        var sector = vm.data.sectors.whatsapp[sector_id];
        sectors[sector_id] = sector.name;
      }
      for (var sector_id in vm.data.sectors.chat) {
        var sector = vm.data.sectors.chat[sector_id];
        sectors[sector_id] = sector.name;
      }
      for (var sector_id in vm.data.sectors.email) {
        var sector = vm.data.sectors.email[sector_id];
        sectors[sector_id] = sector.name;
      }
      for (var sector_id in vm.data.sectors.facebook) {
        var sector = vm.data.sectors.facebook[sector_id];
        sectors[sector_id] = sector.name;
      }
      for (var sector_id in vm.data.sectors.sms) {
        var sector = vm.data.sectors.sms[sector_id];
        sectors[sector_id] = sector.name;
      }
      for (var sector_id in sectors) {
        if (sector_id == 'others') continue;
        csvContent += ',' + sectors[sector_id];
      }
      csvContent += ',';
      for (var status_id in vm.data.status.whatsapp) {
        var status = vm.data.status.whatsapp[status_id];
        statuses[status_id] = status.name;
      }
      for (var status_id in vm.data.status.chat) {
        var status = vm.data.status.chat[status_id];
        statuses[status_id] = status.name;
      }
      for (var status_id in vm.data.status.email) {
        var status = vm.data.status.email[status_id];
        statuses[status_id] = status.name;
      }
      for (var status_id in vm.data.status.facebook) {
        var status = vm.data.status.facebook[status_id];
        statuses[status_id] = status.name;
      }
      for (var status_id in vm.data.status.sms) {
        var status = vm.data.status.sms[status_id];
        statuses[status_id] = status.name;
      }
      for (var status_id in statuses) {
        if (status_id == 'others') continue;
        csvContent += ',' + statuses[status_id];
      }

      if (vm.visibleColunTable('whatsApp')) {
        csvContent += '\n';
        csvContent += 'WhatsApp,';
        for (var sector_id in sectors) {
          if (sector_id == 'others') continue;
          csvContent += ',' + (vm.data.sectors.whatsapp[sector_id] ? vm.data.sectors.whatsapp[sector_id].count : '0');
        }
        csvContent += ',';
        for (var status_id in statuses) {
          if (status_id == 'others') continue;
          csvContent += ',' + (vm.data.status.whatsapp[status_id] ? vm.data.status.whatsapp[status_id].count : '0');
        }
      }

      if (vm.visibleColunTable('chat')) {
        csvContent += '\n';
        csvContent += 'Chat,';
        for (var sector_id in sectors) {
          if (sector_id == 'others') continue;
          csvContent += ',' + (vm.data.sectors.chat[sector_id] ? vm.data.sectors.chat[sector_id].count : '0');
        }
        csvContent += ',';
        for (var status_id in statuses) {
          if (status_id == 'others') continue;
          csvContent += ',' + (vm.data.status.chat[status_id] ? vm.data.status.chat[status_id].count : '0');
        }
      }

      if (vm.visibleColunTable('email')) {
        csvContent += '\n';
        csvContent += 'E-mail,';
        for (var sector_id in sectors) {
          if (sector_id == 'others') continue;
          csvContent += ',' + (vm.data.sectors.email[sector_id] ? vm.data.sectors.email[sector_id].count : '0');
        }
        csvContent += ',';
        for (var status_id in statuses) {
          if (status_id == 'others') continue;
          csvContent += ',' + (vm.data.status.email[status_id] ? vm.data.status.email[status_id].count : '0');
        }
      }

      if (vm.visibleColunTable('facebook')) {
        csvContent += '\n';
        csvContent += 'Facebook,';
        for (var sector_id in sectors) {
          if (sector_id == 'others') continue;
          csvContent += ',' + (vm.data.sectors.facebook[sector_id] ? vm.data.sectors.facebook[sector_id].count : '0');
        }
        csvContent += ',';
        for (var status_id in statuses) {
          if (status_id == 'others') continue;
          csvContent += ',' + (vm.data.status.facebook[status_id] ? vm.data.status.facebook[status_id].count : '0');
        }
      }

      if (vm.visibleColunTable('sms')) {
        csvContent += '\n';
        csvContent += 'SMS,';
        for (var sector_id in sectors) {
          if (sector_id == 'others') continue;
          csvContent += ',' + (vm.data.sectors.sms[sector_id] ? vm.data.sectors.sms[sector_id].count : '0');
        }
        csvContent += ',';
        for (var status_id in statuses) {
          if (status_id == 'others') continue;
          csvContent += ',' + (vm.data.status.sms[status_id] ? vm.data.status.sms[status_id].count : '0');
        }
      }

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'download-rel.csv');
      document.body.appendChild(link);
      link.click();
    }
    vm.downloadCsvOpenClosed = function () {
      var csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += 'Setor,"Atendimentos Recebidos","Atendimentos Finalizados"\n';
      for (var sector in vm.table_data.result) {
        var counts = vm.table_data.result[sector];
        csvContent += '"' + sector + '"' + ',' + counts.all + ',' + counts.closed + '\n';
      }
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'download-rel.csv');
      document.body.appendChild(link);
      link.click();
    };
    vm.downloadCsvSectorStatus = function () {
      var csvContent = 'Número,Atendimentos,';
      // empty column
      for (var i in vm.data_by_number.sectors_titles) {
        csvContent += ',' + vm.data_by_number.sectors_titles[i];
      }
      // empty column
      csvContent += ',';
      for (var i in vm.data_by_number.status_titles) {
        csvContent += ',' + vm.data_by_number.status_titles[i];
      }
      csvContent += '\n';
      // ,Resposta Recebida em,Resposta
      for (var number_id in vm.data_by_number.numbers) {
        var number = vm.data_by_number.numbers[number_id];
        var arr = [
          number.phone_number,
          number.qty,
          ''
        ];
        for (var sector_id in vm.data_by_number.sectors_titles) {
          arr.push(number.sectors[sector_id] || '0');
        }
        arr.push('');
        for (var status_id in vm.data_by_number.status_titles) {
          arr.push(number.status[status_id] || '0');
        }
        csvContent += arr.join(',');
        csvContent += '\n';
      }

      var blob = new Blob([csvContent], { type: 'text/csv' });
      var csvUrl = URL.createObjectURL(blob);

      var anchor = angular.element('<a/>');
      anchor.css({ display: 'none' });
      angular.element(document.body).append(anchor);
      anchor.attr({
        href: csvUrl,
        target: '_self',
        download: 'sectorStatus.csv'
      })[0].click();

      anchor.remove();
      URL.revokeObjectURL(csvUrl);
    };

    vm.calcTotal = function () {
      if (vm.objLength(vm.data) > 0 && vm.data.total > 0) {
        return Object.keys(vm.data.contacts)
          .reduce(function (sum, key) {
            if (vm.visibleColunTable(key)) { return sum + parseFloat(vm.data.contacts[key]); } else { return sum; }
          }, 0);
      }
    }
    vm.calcWidthTable = function () {
      // 100% - 8% da primeira coluna - quantidade de colunas selecionadas
      var length = (vm.filterTable.length > 0) ? vm.filterTable.length : 1;
      return {
        width: Math.trunc((100 - 8) / length) + 'px'
      }
    }
    vm.visibleColunTable = function (type) {
      return (vm.filterTable.filter(function (f) {
        return (f.text.toLowerCase().replace(/[^a-z]/g, '') == type.toLowerCase().replace(/[^a-z]/g, ''))
      }).length > 0)
    }
  }
})();
